import { fromJS, List } from 'immutable';
import Action from 'models/ActionModel';
import { createReducer } from '../../utils/helpers';
import { actions } from './types';

const initialState = fromJS({
  data: null,
  loading: true,
  error: false,
});

export default createReducer(initialState, {
  [actions.request]: (state) => state.set('loading', true),
  [actions.success]: (state, reduxAction) =>
    state
      .set('loading', false)
      .set('error', false)
      .set(
        'data',
        new List(reduxAction.response)
          .map((action) => Action.deserialize(action))
          .sort((a, b) => a.priority - b.priority),
      ),
  [actions.failure]: (state, reduxAction) =>
    state.set('loading', false).set('error', reduxAction.error),
});
